const { defineMessages } = require('@edx/frontend-platform/i18n');

const messages = defineMessages({
  like: {
    id: 'essentials.likeDislikeUnit.likeButton',
    defaultMessage: 'Like',
    description: 'Like button label',
  },
  dislike: {
    id: 'essentials.likeDislikeUnit.dislikeButton',
    defaultMessage: 'Dislike',
    description: 'Dislike button label',
  },
});

export default messages;
